import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import TalkRouter from "./TalkRouter.js";
import ArticleRouter from "./ArticleRouter.js";
import DictionaryRouter from "./DictionaryRouter.js";

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Home/Home.vue'),
    meta: { code: 'home' }
  },
  {
    path: '/picture-read',
    name: 'PictureRead',
    component: () => import('@/views/Picture/PictureRead/PictureRead.vue'),
    meta: { code: 'pictureRead' }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/Search/Search.vue'),
    meta: { code: 'search' }
  },
  {
    path: '/hot-recommend',
    name: 'HotRecommend',
    component: () => import('@/views/Recommend/HotRecommend.vue'),
    meta: { code: 'hotRecommend' }
  },
  {
    path: '/boutique-recommend',
    name: 'BoutiqueRecommend',
    component: () => import('@/views/Recommend/BoutiqueRecommend.vue'),
    meta: { code: 'boutiqueRecommend' }
  },
].concat(TalkRouter).concat(ArticleRouter).concat(DictionaryRouter)

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',   // 模式，默认hash
  routes
})

export default router
